import { render, staticRenderFns } from "./VRevenueStatisticalCard.vue?vue&type=template&id=b3f46858"
import script from "./VRevenueStatisticalCard.vue?vue&type=script&lang=js"
export * from "./VRevenueStatisticalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports